import {  Grid } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'
import { useParams } from 'react-router-dom'
import CargoViewForm from './CargoViewPage'
import Namespace from 'src/constants/locale/Namespace'
import CargoKeys from 'src/constants/locale/key/AciHighwayCargo'
import ResponseMessage from '../response/ResponseMessage'
import ACIHighwayCargoTranslationText from './../contexts/ACIHighwayCargoTranslationText'

const { CngTabs } = components

function ViewPage(props) {
  const { location, showNotification } = props
  const { state } = location
  const { id } = useParams()
  const { translate } = useTranslation([Namespace.ACI_HIGHWAY_CARGO])
  //const translatedTextsObject = makeTranslatedTextsObject()
  const aciHighwayCargoTranslationText = ACIHighwayCargoTranslationText() 

  const [ccnValue , setCCNValues ] = useState('')
  function setCCNValue(ccnValue){
    setCCNValues(ccnValue)
  }

  const [manifestId , setManifestIds ] = useState('')
  function setManifestId(manifestId){
    setManifestIds(manifestId)
  }

 /* function makeTranslatedTextsObject() {
    let viewCargo = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      CargoKeys.VIEW_CARGO
    )
    let cargoResponse= translate(
      Namespace.ACI_HIGHWAY_CARGO,
      CargoKeys.RESPONSE_TITLE
    )

    return {
      viewCargo,
      cargoResponse
    }
  }*/

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CngTabs activeTabIndex={state?.active ? state.active : 0}
          headerColor='primary'
          tabs={[
            {
              tabName: aciHighwayCargoTranslationText.viewCargo,
              tabContent: (
                <CargoViewForm
                  showNotification={showNotification}
                  id={id}
                  setCCNValue={setCCNValue}
                  setManifestId={setManifestId}
                />
              )
            },
            {
              tabName: aciHighwayCargoTranslationText.cargoResponse,
              tabContent: (
                <ResponseMessage
                  showNotification={showNotification}
                  id={id}
                  isViewOnly={true}
                  ccnValue={ccnValue}
                  manifestId={manifestId}
                  cargoPage={true}
                  manifestPage={false}
                />
              )
            }
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default ViewPage
